import { Tag } from "antd";
import styled from "styled-components";

export const TagStyled = styled(Tag)`
  height: 34px;
  display: flex;
  align-items: center;
`;
